import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../../../api/context';
import Icon from '../../../../components/Icon';
import { Title } from '../../../../utils/title';
import toast from '../../../../utils/toast';
import Layout from '../Layout';
import styles from './Email.module.scss';

const Email = () => {

  const [ loading, setLoading ] = useState(true);
  const [ initial, setInitial ] = useState({
    email_unsub: '',
  });

  const { token } = useAPIContext();

  useEffect(() => {

    api(token).v1.profile.query()
      .then(res => {
        if (res.status === 200) {
          setLoading(false);
          setInitial({
            email_unsub:
              res.body.data.email_unsub.value
              ? 'Y'
              : 'N',
          });
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token]);

  return (
    <>
      <Title value='Email - Profile' />
      <Layout>
        <div className={styles.root}>
          <div className={styles.content}>
            <div className={styles.header}>
              <Link
                to='/profile'
                aria-label='go back'>

                <Icon name={'arrow_back'} />

              </Link>

              <h1>Email Settings</h1>
            </div>

            <Formik
              enableReinitialize={true}
              initialValues={initial}
              validationSchema={yup.object({
                email_unsub: yup.string()
                  .required('Required'),
              })}
              onSubmit={(values, actions) => {

                if (loading) {
                  return;
                }

                setLoading(true);

                api(token).v1.profile
                  .update(values)
                  .then(res => {
                    setLoading(false);

                    if (res.status === 200) {
                      toast.show(toast.KIND.SUCCESS, 'Email settings saved.');
                    }

                    if (res.status === 400) {
                      toast.show(toast.KIND.ERROR, res.body);
                    }
                  })
                  .catch(err => {
                    setLoading(false);
                    toast.show(toast.KIND.WARNING, err);
                  });

              }} >

              <Form>
                <div>
                  <label htmlFor='email_unsub'>
                    <b>Unsubscribe</b> from all email communications?
                  </label>
                  <Field
                    id='email_unsub'
                    as='select'
                    aria-label='unsubscribe'
                    name='email_unsub'
                    disabled={loading} >

                    <option value=''></option>
                    <option value='Y'>Yes, disable emails</option>
                    <option value='N'>No, enable emails</option>
                  </Field>
                  <ErrorMessage
                    name='email_unsub'
                    component='div'
                  />
                </div>

                <button
                  type='submit'
                  disabled={loading}>

                  Save

                </button>
              </Form>

            </Formik>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Email;